import { makeStyles } from "@material-ui/core/styles";
import * as colors from "../../../../theme/colors";

const useStyles = makeStyles(() => ({
  item: {
    display: "block",
    width: "100%",
    textAlign: "left",
    fontFamily: "Roboto",
    borderRadius: 8,
    border: `1px solid ${colors.ideGrey100}`,
    padding: '12px 16px',
    marginBottom: 8,
    cursor: "pointer",
  },

  header: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: "24px",
    color: colors.darkBlue900,
    display: "flex",
    marginBottom: 7
  },

  headerIcon: {
    width: 24,
    height: 24,
    marginRight: 14,
  },

  content: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "16px",
    color: colors.ideBlack900,
  },

}));

export { useStyles };
